import { render, staticRenderFns } from "./zimmerkontingente-widget.vue?vue&type=template&id=349db763&scoped=true"
import script from "./zimmerkontingente-widget.vue?vue&type=script&lang=js"
export * from "./zimmerkontingente-widget.vue?vue&type=script&lang=js"
import style0 from "./zimmerkontingente-widget.vue?vue&type=style&index=0&id=349db763&prod&lang=scss&scoped=true"
import style1 from "./zimmerkontingente-widget.vue?vue&type=style&index=1&id=349db763&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349db763",
  null
  
)

export default component.exports